import { ListResponse, PaginationRequest } from './client/types'
import { useAPI } from './client/useAPI'

export type RefundListItem = {
  id: string
  amount: string
  amountCurrency: string
  comment: string
  createdAt: string
  orderId: string
}

export type RefundsRequest = PaginationRequest & {
  orderId: string | null
}

type RefundsResponse = ListResponse<RefundListItem>

export const useRefunds = () => {
  return useAPI<RefundsResponse, RefundsRequest>('GET', '/refunds', {
    withToken: true,
  })
}
